var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.gameId == 0
        ? _c(
            "div",
            [
              _c(
                "v-row",
                {
                  attrs: {
                    align: "center",
                  },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex",
                      attrs: {
                        cols: "12",
                        sm: "6",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.slugList,
                          "item-text": "name",
                          "item-value": "slug",
                          label: "เลือกประเภทเกมส์",
                          outlined: "",
                        },
                        on: {
                          change: _vm.getGameLists,
                        },
                        model: {
                          value: _vm.query.slug,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "slug", $$v)
                          },
                          expression: "query.slug",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex",
                      attrs: {
                        cols: "12",
                        sm: "6",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.gameList,
                          "item-text": "name",
                          "item-value": "id",
                          label: "เลือกรอบเกมส์",
                          outlined: "",
                        },
                        model: {
                          value: _vm.query.gameId,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "gameId", $$v)
                          },
                          expression: "query.gameId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        lg: "6",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-items-baseline my-2",
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mx-3",
                            attrs: {
                              "prepend-icon": "mdi-magnify",
                              autocomplete: "off",
                              "hide-details": "",
                              label: "ค้นหา",
                              clearable: "",
                            },
                            on: {
                              input: function ($event) {
                                _vm.query.text = $event
                              },
                            },
                            model: {
                              value: _vm.query.text,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "text", $$v)
                              },
                              expression: "query.text",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                              },
                              on: {
                                click: _vm.fetchData,
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    left: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              mdi-check\n            "
                                  ),
                                ]
                              ),
                              _vm._v("\n            ค้นหา\n          "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-0",
        attrs: {
          "footer-props": _vm.footer,
          headers: _vm.headers,
          items: _vm.items,
          loading: _vm.loading,
          "multi-sort": false,
          options: _vm.options,
          "server-items-length": _vm.totalItems,
          "item-key": "id",
        },
        on: {
          "update:items": function ($event) {
            _vm.items = $event
          },
          "update:options": function ($event) {
            _vm.options = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.detail",
            fn: function (_ref) {
              var item = _ref.item
              return [
                _c(
                  "div",
                  {
                    staticClass: "text-center",
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          icon: "",
                          color: "green darken-3",
                          title: "ดูรายละเอียด",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.displayDialog(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("mdi-magnify")])],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "item.name",
            fn: function (_ref2) {
              var item = _ref2.item
              return [
                _c(
                  "span",
                  {
                    staticClass: "text-info",
                  },
                  [_vm._v(_vm._s(item.user.name))]
                ),
              ]
            },
          },
          {
            key: "item.game_name",
            fn: function (_ref3) {
              var item = _ref3.item
              return [
                _c(
                  "span",
                  {
                    staticClass: "text-danger",
                  },
                  [
                    _vm._v(
                      _vm._s(item.game.master.name) +
                        " " +
                        _vm._s(item.game.readable_edition) +
                        " " +
                        _vm._s(item.game.game_thai_date)
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "item.created_at",
            fn: function (_ref4) {
              var item = _ref4.item
              return [
                item.created_at
                  ? _c(
                      "span",
                      {
                        staticClass: "d-block",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm
                              .$moment(item.created_at)
                              .format("YYYY-MM-DD HH:mm:ss")
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.amount",
            fn: function (_ref5) {
              var item = _ref5.item
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      Number(item.amount).toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                      })
                    )
                  ),
                ]),
              ]
            },
          },
          {
            key: "item.win_amount",
            fn: function (_ref6) {
              var item = _ref6.item
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      item.win_amount
                        ? Number(item.win_amount).toLocaleString("en-US", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })
                        : 0
                    )
                  ),
                ]),
              ]
            },
          },
          {
            key: "item.status",
            fn: function (_ref7) {
              var item = _ref7.item
              return [
                item.status === "pending"
                  ? _c(
                      "v-chip",
                      {
                        staticClass: "ma-2 text-lg",
                        attrs: {
                          label: "",
                          small: "",
                          color: "light-blue",
                          "text-color": "white",
                        },
                      },
                      [_vm._v("\n        กำลังประมวลผล\n      ")]
                    )
                  : item.status === "created"
                  ? _c(
                      "v-chip",
                      {
                        staticClass: "ma-2 text-lg",
                        attrs: {
                          label: "",
                          small: "",
                          color: "light-blue",
                          "text-color": "white",
                        },
                      },
                      [_vm._v("\n        รอยืนยันผล\n      ")]
                    )
                  : item.status === "cancel_by_game"
                  ? _c(
                      "v-chip",
                      {
                        staticClass: "ma-2 text-lg",
                        attrs: {
                          label: "",
                          small: "",
                          color: "primary",
                        },
                      },
                      [_vm._v("\n        ยกเลิกเกมส์\n      ")]
                    )
                  : item.status === "cancel_by_user"
                  ? _c(
                      "v-chip",
                      {
                        staticClass: "ma-2 text-lg",
                        attrs: {
                          label: "",
                          small: "",
                          color: "primary",
                        },
                      },
                      [_vm._v("\n        ยกเลิกโพย\n      ")]
                    )
                  : item.status === "committed"
                  ? _c(
                      "v-chip",
                      {
                        staticClass: "ma-2 text-lg",
                        attrs: {
                          label: "",
                          small: "",
                          color: "light-blue",
                          "text-color": "white",
                        },
                      },
                      [_vm._v("\n        กำลังคำนวน\n      ")]
                    )
                  : item.status === "complete"
                  ? _c(
                      "v-chip",
                      {
                        staticClass: "ma-2 text-lg",
                        attrs: {
                          label: "",
                          small: "",
                          color: "success",
                        },
                      },
                      [_vm._v("\n        จบเกมส์\n      ")]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.id",
            fn: function (_ref8) {
              var item = _ref8.item
              return [
                _c("span", [
                  _vm._v(_vm._s(`#${item.lotto_game_id}${item.id}`)),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.selectedItem
        ? _c(
            "v-dialog",
            {
              attrs: {
                width: "1120",
                "max-width": "100vw",
                scrollable: "",
              },
              model: {
                value: _vm.selectedItem,
                callback: function ($$v) {
                  _vm.selectedItem = $$v
                },
                expression: "selectedItem",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: {
                        dark: "",
                        color: "primary",
                      },
                    },
                    [
                      _c("v-card-title", [
                        _c(
                          "span",
                          {
                            staticClass:
                              "text-body-1 text-uppercase text-monospace",
                          },
                          [_vm._v(_vm._s(_vm.gameName))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.closeDialog()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    {
                      staticClass: "pt-10",
                    },
                    [
                      _c("ticket-number", {
                        attrs: {
                          transaction: _vm.ticketNumberItem,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.preload
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                width: "500",
                "max-width": "100vw",
              },
              model: {
                value: _vm.preload,
                callback: function ($$v) {
                  _vm.preload = $$v
                },
                expression: "preload",
              },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-md-10 mx-lg-auto",
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "text-center",
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          size: 100,
                          width: 10,
                          indeterminate: "",
                          color: "primary",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("b-modal", {
        attrs: {
          id: "bv-modal-result",
          size: "xl",
          "hide-footer": "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }